(() => {
  const TARGET = '.c-featured-collections .c-product-card, .c-silveregg-recommend .c-product-card, .c-zeta-ranking .c-product-card, .shopify-section--featured-collections product-item, product-recommendations product-item, .featured-collection-grid .product-item';
  const COLOR_NAMES = ['カラー', 'color', '色'];
  const COLORS = [
    [['バーガンディ', 'バーガンディー', 'ボルドー', 'burgundy', 'bordeaux'], '#800020'],
    [['インディゴ', 'indigo'], '#263b66'],
    [['スミクロ', '墨黒', 'チャコールブラック'], '#333333'],
    [['ネイビー', '紺'], '#1e233a'], [['ブラック', '黒'], '#000000'],
    [['チャコール', 'ダークグレー', 'グレー', '灰'], '#888888'],
    [['ホワイト', '白', 'アイボリー', 'エクリュ'], '#f4f1e8'],
    [['ブラウン', '茶'], '#8f7a66'], [['ベージュ', 'カーキ'], '#b8b09c'],
    [['グリーン', '緑'], '#283a1e'], [['サックス', '水色'], '#45b7b9'],
    [['ブルー', '青'], '#4f73bb'], [['パープル', '紫'], '#7e4fbb'],
    [['レッド', '赤', 'ワイン'], '#bb4f51'], [['オレンジ', '橙'], '#d69a6a'],
    [['ピンク'], '#b89c9c'], [['イエロー', '黄'], '#b9b145'],
  ];
  const cache = new Map();
  const colorFor = (name) => COLORS.find(([words]) => words.some((word) => String(name).includes(word)))?.[1] || '#cccccc';
  const imageName = (url) => {
    if (!url) return '';
    try { return decodeURIComponent(new URL(String(url).replace(/^\/\//, 'https://'), location.origin).pathname.split('/').pop() || '').toLowerCase(); }
    catch (_) { return String(url).split('?')[0].split('/').pop().toLowerCase(); }
  };
  const handleFor = (card) => card.querySelector('wishlist-button-collection[data-product-handle]')?.dataset.productHandle
    || card.querySelector('a[href*="/products/"]')?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1] || '';
  const fetchProduct = (handle) => {
    if (!cache.has(handle)) cache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`).then((response) => response.ok ? response.json() : null).catch(() => null));
    return cache.get(handle);
  };
  const money = (value) => `¥${Math.round((Number(value) || 0) / 100).toLocaleString('ja-JP')}`;
  async function initialize(card) {
    if (card.dataset.colorChipSwitch === '1') return;
    card.dataset.colorChipSwitch = '1';
    const handle = handleFor(card);
    if (!handle) return;
    const product = await fetchProduct(handle);
    if (!product || !card.isConnected) return;
    const optionIndex = (product.options || []).findIndex((option) => {
      const name = String(typeof option === 'string' ? option : option?.name || '').toLowerCase();
      return COLOR_NAMES.some((keyword) => name.includes(keyword));
    });
    if (optionIndex < 0) return;
    const names = [...new Set((product.variants || []).map((variant) => String(variant.options?.[optionIndex] || '').trim()).filter(Boolean))];
    if (names.length === 0) return;
    const primaryImage = card.querySelector('.c-product-card__image:not(.c-product-card__image--secondary), .product-item__primary-image, .product-item__image .image__img, [data-zeta-image], [data-silveregg-image]');
    const shownImage = imageName(primaryImage?.currentSrc || primaryImage?.src || product.featured_image);
    const initialVariant = (product.variants || []).find((variant) => imageName(variant.featured_image?.src) === shownImage);
    const initialColor = String(initialVariant?.options?.[optionIndex] || '').trim();
    const title = card.querySelector('.c-product-card__title, .product-item-meta__title, .product-item__product-title a, [data-zeta-title], [data-silveregg-title]');
    const price = card.querySelector('.c-product-card__price, .price-list .price, .product-item__text > .product-item__price, [data-zeta-price], [data-silveregg-price]');
    const sold = card.querySelector('.c-product-card__sold, [data-zeta-sold], [data-silveregg-sold]');
    const links = card.querySelectorAll('a[href*="/products/"], [data-zeta-link], [data-silveregg-link]');
    const wishlist = card.querySelector('wishlist-button-collection');
    let list = card.querySelector('.c-product-card__swatches');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'c-product-card__swatches';
      const host = card.querySelector('.product-item__text') || title?.parentElement || price?.parentElement || card;
      const anchor = card.querySelector('.product-item-meta__price-list-container') || (price?.parentElement === host ? price : null) || title?.nextSibling || null;
      host.insertBefore(list, anchor);
    }
    list.replaceChildren();
    list.hidden = false;
    list.setAttribute('aria-label', 'カラー展開');
    names.forEach((name) => {
      const variant = (product.variants || []).find((item) => item.available && String(item.options?.[optionIndex] || '').trim() === name && item.featured_image?.src)
        || (product.variants || []).find((item) => String(item.options?.[optionIndex] || '').trim() === name);
      const li = document.createElement('li');
      li.className = 'c-product-card__swatch';
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'c-product-card__swatch-dot';
      dot.style.backgroundColor = colorFor(name);
      dot.title = name;
      dot.setAttribute('aria-label', `${name}を表示`);
      const selected = Boolean(initialColor) && initialColor === name;
      dot.classList.toggle('is-selected', selected);
      dot.setAttribute('aria-pressed', selected ? 'true' : 'false');
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        list.querySelectorAll('.c-product-card__swatch-dot').forEach((item) => {
          const active = item === dot;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (variant?.featured_image?.src && primaryImage) {
          primaryImage.src = variant.featured_image.src;
          primaryImage.removeAttribute('srcset');
          primaryImage.alt = `${product.title} ${name}`;
        }
        const url = variant?.id ? `/products/${encodeURIComponent(handle)}?variant=${variant.id}` : `/products/${encodeURIComponent(handle)}`;
        links.forEach((link) => { link.href = url; });
        if (price && variant) price.textContent = money(variant.price);
        if (sold && variant) sold.hidden = Boolean(variant.available);
        if (wishlist && variant?.id) {
          wishlist.dataset.variantId = String(variant.id);
          wishlist.setAttribute('data-variant-id', String(variant.id));
        }
      });
      li.appendChild(dot);
      list.appendChild(li);
    });
  }
  const scan = (root = document) => root.querySelectorAll(TARGET).forEach((card) => void initialize(card));
  const observer = new MutationObserver(() => scan());
  const start = () => { scan(); observer.observe(document.body, { childList: true, subtree: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
